module.exports = __webpack_public_path__ + "public/images/netw-choose-company-mobile.9e456a1d08deb624bf0b9a68999cf712.jpg";